import { Body1Strong, Divider } from '@fluentui/react-components';

import { TReplica, TSparseReplica } from '@modules/replicas';
import { TERMINOLOGY } from '@shared/i18n';
import ReplicaListingsTree from './ReplicaListingsTree';

type TProps = {
  replica?: TReplica;
  replicaListings?: TSparseReplica[];
  versions: { id: string }[];
};

/** Renders the replica listings section with a divider, heading, and tree. Renders nothing when hidden. */
const ReplicaListingsSection = ({ replica, replicaListings, versions }: TProps) => {
  if (replica || !replicaListings || replicaListings.length === 0) return null;

  return (
    <>
      <Divider className="py-3" />
      <p className="px-3 pb-2">
        <Body1Strong>{TERMINOLOGY.replica.upperPlural}</Body1Strong>
      </p>
      <div className="px-2">
        <ReplicaListingsTree replicaListings={replicaListings} versions={versions} />
      </div>
    </>
  );
};

export default ReplicaListingsSection;
